HafasWebapp.prototype.subscriptions.mapsearch = function (_me) {
  Hafas.ps.sub('/GUI/sidedrawer/onChanged', Hafas.bind(_me.Controller.MapSearch.onSidedrawerChanged, _me));
  Hafas.ps.sub('/MapSearchMobile/Show', Hafas.bind(_me.Controller.MapSearch.showMobile, _me));
  Hafas.ps.sub('/MapSearchMobile/Hide', Hafas.bind(_me.Controller.MapSearch.hideMobile, _me));
  Hafas.ps.sub('/MapSearchMobile/Init', Hafas.bind(_me.Controller.MapSearch.initMobile, _me));
}